module.exports = __webpack_public_path__ + "static/media/bag1.7bf226ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/bag1.jpg
// module id = 185
// module chunks = 0